import { Directive, ElementRef, Input } from '@angular/core';

export type PcpIconButtonSize = 'small' | 'medium' | 'large' | 'xlarge';

@Directive({ selector: '[pcpUiIconButton], [pcp-ui-icon-button]' })
export class IconButtonDirective {
    @Input({ required: true }) set size(value: PcpIconButtonSize) {
        //console.log('set size', [value, this.el.nativeElement]);
        this.el.nativeElement.classList.remove('pcp-ui-icon-button--small', 'pcp-ui-icon-button--medium', 'pcp-ui-icon-button--large', 'pcp-ui-icon-button--xlarge');
        this.el.nativeElement.classList.add(`pcp-ui-icon-button--${value}`);
    }

    constructor(private el: ElementRef) {
        this.el.nativeElement.classList.add('pcp-ui-icon-button');
    }
}
